import { boolean  } from 'boolean'
import moment from 'moment'

export const APP_URL         = process.env.APP_URL
export const APP_DUO_ENABLED = boolean(process.env.DUO_ENABLED)
export const IS_PRODUCTION   = process.env.APP_ENV === 'production'

export const CURRENT_YEAR        = ( new Date() ).getFullYear()
export const DATE_FORMAT         = 'YYYY-MM-DD'
export const DATE_TIME_FORMAT    = 'YYYY-MM-DD h:mm a'

export const MONTHS              = moment.monthsShort()

export const STATISTIC_TYPES   = [ 'traffic', 'packets', 'errors' ]
export const STATISTIC_PERIODS = [ 'day', 'week', 'month', 'year' ]

export const TICKETING_ATTACH_FILE_TYPES = process.env.TICKETING_ATTACH_FILE_TYPES ?? '.gif, .jpg, .png, .pdf, .txt, .log, .csv, .vsd, .doc, .docx, .xls, .xlsx'

// Zones

export const ZONE_RECORD_GROUP_SIZE     = 19
export const ZONE_RECORD_EDIT_ALL_EMPTY = "Please make sure all name and value fields are populated.";

export const ZONE_RECORD_CAA_FLAGS = [ 0, 1, 128 ]
export const ZONE_RECORD_CAA_TAGS  = [ 'issue', 'issuewild', 'iodef' ]

export const ZONE_MASTER_DELETE_MESSAGE = "Zone has been deleted."

export const HTTP_METHOD_VARIANTS =
{
	'GET':     'success',
	'HEAD':    'dark',
	'OPTIONS': 'dark',
	'POST':    'primary',
	'PUT':     'warning',
	'PATCH':   'info',
	'DELETE':  'danger',
}

export const LOGIN_TEXT =
{
    USERNAME:
    {
        CUSTOMER: "Customer Email",
        EMPLOYEE: "Cogent Username",
    },

    RADIO:
    {
        CUSTOMER: "Valued Customer",
        EMPLOYEE: "Cogent Employee",
    },
}


export const ORDER_TRACKING_DESCRIPTIONS =
{
    CREDIT_REVIEW:
    {
        TITLE:    "Credit Review",

        ESTIMATED_TIME: "1 - 5 business days",

        DESCRIPTION:
        [
            `Extending credit to companies is an essential part of business. For new COGENT customers, you may have
            completed a Credit Check form or submitted credit references. Credit Review for companies with a D&B D-U-N-S®
            Number can occur quickly. Alternatively, we'll check bank references listed on the Credit Check Form. Sometimes,
            Credit Review is delayed because a reference takes a long time to respond.`,

             `To bypass Credit Review, new COGENT customers can elect to make a prepayment in the amount equal to one month
             Monthly Recurring Charges plus the full Installation Charge. Note this is prepayment and NOT a deposit.`,

             `For existing COGENT customers ordering new service , your existing account(s) must be current, i.e., your
             Current Balance is no greater than your Last Invoice Amount.`,

             `If you have questions regarding Credit Review or would like to arrange a prepayment, please contact us and have your Order ID ready.`,
        ],

    },

    ORDER_VALIDATION:
    {
        TITLE: "Order Validation",

        ESTIMATED_TIME: "2 business days",

        DESCRIPTION:
        [
            `Once Cogent receives your CSA, typically via our online electronic signature service, we review the CSA for accuracy
            and completeness. This includes a review of the Order Form, Terms & Conditions , Product Rider, Country Rider, Addendums,
            and technical questionnaires such as the IP Questionnaire, BGP Questionnaire, SMTP Questionnaire, DNS Questionnaire, and
            Utility Computing Questionnaire. Your particular contract documents will vary depending on the type of service you ordered
            and the location you want the service installed.`,

            `in most cases, the process includes a telephone conversation with the technical contact listed on your Order Form. During
            this brief conversation, we review and confirm the details on your Order Form. We call every telephone number listed on your
            Order Form to try and reach you. If we didn't get you on our first try, please call us back!`,

            `Every order for COGENT service is subject to Order Validation. It promotes order accuracy and timely service installation.
             We want to get it right the first time-what you ordered, where you want it, when you'll receive it, and who to contact if
             there are problems.`
        ],

    },

    COORDINATOR_ASSIGNMENT:
    {
        TITLE: "Coordinator Assignment",

        ESTIMATED_TIME: "1 business day",

        DESCRIPTION:
        [
            `A Service Coordinator-serving as your single point of contact during the installation process-is assigned to each order.
             Your Service Coordinator facilitates the installation process and is available to answer any of your questions.
             Once the assignment is complete, the name and contact information for your Service Coordinator will appear below your
             Installation Status Bar`,

            `The Target Installation Date will also change from "Pending" to an actual date.`,

            `Once your Service Coordinator is assigned, we strongly recommend that you communicate with your Service Coordinator
             rather than your Sales Representative regarding your service installation. Your Service Coordinator simply has the
             most accurate and up-to-date information.`,
        ],
    },

    ON_NET_BANDWIDTH_PROVISIONING:
    {
        TITLE: "On-Net Bandwidth Provisioning",

        ESTIMATED_TIME: '17 business days',

        DESCRIPTION:
        [
            `Your Service Coordinator will call you to review your service criteria and will send you a Welcome email. Please respond
                       and verify your service address and onsite contact information. Your Welcome email contains links to the COGENT Customer
                       User Guide and other important forms.`,

            {
                HEADER: "Behind the scenes, your Service Coordinator is managing all the requirements for your service to ensure timely installation within a short interval. This typically includes:",

                BODY:
                [
                    `1) Reviewing your order with your COGENT Network Planning Engineer to confirm adequate bandwidth and available ports
                        on the network. COGENT strategically over-provisions its network to promote a rapid installation process. While uncommon,
                        a very large or complex order could require augmenting the network with new equipment or transport capacity.`,

                     `2) Creating a Work Order for your COGENT Field Engineer who will schedule a site survey. During this evaluation of the physical
                        installation location, we determine how COGENT fiber will be brought to your office suite. COGENT fiber often exists in the
                        building riser system, so cabling is pulled from the riser to your office suite. Your Field Engineer will ultimately activate and test your port.`,

                    `3) Requesting IP address space and BGP, SMTP, and DNS services through your COGENT IP Engineer. When allocating IP
                        resources, your IP Engineer must adhere to accepted Internet standards established by the governing Regional Internet
                        Registry. Your IP Engineer documents your IP resources and configures your port on the COGENT network. Your IP Engineer
                        also assigns VLAN numbers for Point-to-Point services.`
                ],
            },

             `Once your service is successfully tested for continuity and connectivity, your Service Coordinator will notify you and
                email you a Customer Acceptance Letter. Your Customer Acceptance Letter includes contact information for Customer Support.
                Billing of the service commences on the day the Customer Acceptance Letter is sent.`
        ],
    },

    OFF_NET_BANDWIDTH_PROVISIONING:
        {
            TITLE: "Off-Net Bandwidth Provisioning",

            ESTIMATED_TIME:
            [
                'Ethernet Loop = 90 business days',
            ],

            DESCRIPTION:
            [
                `Your Service Coordinator will call you to review your service criteria and will send you a Welcome email. Please respond and verify your service address and onsite contact information.
                Your Welcome email contains links to the COGENT Customer User Guide and other important forms.`,

                {
                    HEADER: "Behind the scenes, your Service Coordinator is managing the partnership between COGENT and the 3rd party access provider who will be providing connectivity at your service location. This includes a host of activities, including the following 3 milestones:\n",

                    BODY:
                        [
                            `1) Metro Network Facilities Check: Cogent has your bandwidth allocated and available on our network today.
                            However, your specific address is "Off-Net" for Cogent, and we will employ a 3rd party access provider to
                            connect your location to our network to obtain that bandwidth. The access provider will issue internal orders
                            to determine if metro network facilities are already available to provide the service end-to-end. If such facilities
                            are available, the order will proceed to the provider's provisioning process. If there are portions of the route across
                            the provider's metro network that require additional facilities, the provider will issue the appropriate work orders, permits, etc.,
                            to construct them and advise a forecasted timeline for the completion.`,

                            `2) Site Survey Customer Premises Site Survey: The 3rd party access provider will dispatch a certified Engineer to perform a site visit with your local contact.
                            This site visit will determine the necessary infrastructure within your property to support the service that will be installed. The engineer will review both the infrastructure that is already in place and can be utilized,
                            as well as items that are not in place and need to be provided. These requirements vary by location, but typically involve:

                                - Installation space, such as a regulation plywood backboard on which to mount equipment (or telecommunications relay rack space).

                                - Power for the provider's equipment in the proximity of where it will be installed.

                                - Pathway for fiber from the property line to the provider's demarcation or minimum point of entry (MPOE), and possibly internal conduit or riser path from the MPOE to your suite.

                            Once the access provider determines these needs and communicates them to your local installation contact, it is your responsibility to meet these requirements, either via a
                            hired contractor, or working with the building property manager. Providing these requirements in a timely manner is one of the best ways to ensure a delivery with minimal delays.`,

                            `3) LEC FOC Date: This is the "Firm Order Commitment" date which the access provider expects to have the network installed at your location. The access provider may be performing physical work
                            at your location on this day, or in the days leading up to this date. Cogent's activation date will typically be 3 to 5 business days after the LEC FOC date, once the provider and Cogent have established
                            continuity between the newly-installed circuit and the Cogent network.`
                        ],
                },

                `Once your service is successfully tested for continuity and connectivity, your Service Coordinator will notify you and email you the Customer Acceptance Letter. Your Customer Acceptance Letter includes contact information for Customer Support`
            ],
        }
}

export const DUPLICATE_QUESTIONS_MSG = 'Questions selected must be unique. Please recheck all questions to see if they are all unique.'
export const MESSAGE_USER_DATA_DNE   = 'Customer verification information does not match our records. Please contact support at support@cogentco.com.'

export const SDWAN_TRAFFIC_SHAPING_LABELS =
{
   template_one:   'Equal:',
   template_two:   'Voice Only:',
   template_three: 'Voice + Cloud:',
}

export const SDWAN_TRAFFIC_SHAPING_TEMPLATES =
{
    template_one:   'All traffic is treated the same.',
    template_two:   'Video conferencing services are the highest priority.  These currently include:',
    template_three: 'Video Conferencing services are the highest priority, Databases and Cloud Services are medium priority with all other traffic in the lowest queue.  The video conferencing services are previously listed, the Databases and Cloud Services included are:',
}

export const SDWAN_VIDEO_CONFERENCING_SERVICES =
[
    "i.        Dropcam",
    "ii.       SCCP (Skinny Call Control Protocol)",
    "iii.      SIP (Voice)",
    "iv.       Skype",
    "v.        Vocera",
    "vi.       Webex",
]

export const SDWAN_DATABASE_CLOUD_SERVICES =
[
    "i.        Amazon RDS",
    "ii.       Amazon Redshift",
    "iii.      Azure",
    "iv.       IBM Cloud",
    "v.        SAP Cloud Platform",
    "vi.       SAP Hana",
]

export const SDWAN_SPLIT_TUNNEL_CONFIG = 'Do you want all the traffic including internet traffic to go back to the hub location over the tunnel? If so, select Yes. We will configure the CPE with just a default route. If you do not want internet traffic to go back to the hub location  over the tunnel, select no. We will configure the CPE with split tunnel config.'

// Questionnaire constant names

export const QUESTIONNAIRE_L2     = "L2"
export const QUESTIONNAIRE_BGP    = "BGP"
export const QUESTIONNAIRE_IPV6   = "IPv6"
export const QUESTIONNAIRE_IPV4   = "IPv4"
export const QUESTIONNAIRE_SDWAN  = "SDWAN"
export const QUESTIONNAIRE_CREDIT = "CREDIT"